import React, {useEffect, useState} from "react";
import UserAvatar from "./user-avatar";
import client from "../modules/client";
import HelperService from "../services/helper-service";
import {Modal} from "react-bootstrap";
import Section from "./section";
import {useMediaService} from "../services/media-service";
import {useGlobalNotificationMessage} from "../context/message";

export default function ChangeUserAvatar({user, callback, ...props}) {

    const [showUploadModal, setShowUploadModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const {addErrorMessage} = useGlobalNotificationMessage();
    let mediaService = useMediaService();


    async function onUploadFileSelected(event) {
        setSelectedFile(event?.target?.files?.length>0 ? event.target.files[0] : null);
    }

    async function uploadImage(event) {
        event.preventDefault();
        try{
            //get aws url
            mediaService.prepareUpload({
                directory: 'users',
                file_name: `${user.id}_${Date.now()}.jpg`,
                file_type: imagePreview.type,
                meta_type: 'user_photo',
            }).then((res)=>{
                //put file to s3
                fetch(res.signed_request, {
                    method: 'PUT',
                    body: imagePreview,
                    headers: {
                        'Content-Type': imagePreview.type
                    }
                }).then(() => {
                    //set the state to update photo on save
                    if (typeof callback === 'function'){
                        callback(res)
                    }
                }).catch((err) => {
                    HelperService.handleApiErrors(err, addErrorMessage);
                });

            }).catch((err)=>{
                HelperService.handleApiErrors(err, addErrorMessage);
            })

        } catch (err) {
            HelperService.handleApiErrors(err, addErrorMessage);
        }
        setShowUploadModal(false)
    }

    useEffect(() => {
        // If a file is selected, generate and set image preview
        if (selectedFile) {
            prepareProfileImage(selectedFile).then((resized)=>{
                setImagePreview(resized);
            }).catch((err)=>{
                HelperService.handleApiErrors(err, addErrorMessage);
            })
        } else {
            setImagePreview(null);
        }
    }, [selectedFile]);

    const prepareProfileImage = (file) => new Promise((resolve, reject) => {
        const img = document.createElement("img");
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        img.onload = () => {
            const scaleFactor = Math.min((500 / img.width), (500 / img.height));
            canvas.width = img.width * scaleFactor;
            canvas.height = img.height * scaleFactor;

            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            const dataURL = canvas.toDataURL("image/jpeg", 0.8);
            canvas.toBlob((blob) => {
                resolve(new File([blob], "resized.jpg", { type: "image/jpeg" }));
            }, "image/jpeg", 0.8);
        };
        img.onerror = reject;
        img.src = URL.createObjectURL(file);
    });

    const UploadModal = function () {
        const closeModal = () => setShowUploadModal(false);

        return <Modal size='md' show={!!showUploadModal} onHide={closeModal} centered>
            <Modal.Header closeButton>
                <h4 className="header-stripe-blue pb-1">Upload profile image</h4>
            </Modal.Header>
            <Modal.Body className="p-5">
                <Section>
                    <div className="row pb-3">
                        <div className="col-sm-12 mb-3">
                            <form onSubmit={uploadImage}>
                                <div className="form-group">
                                    {!selectedFile && <>
                                        <h5>Select file to upload</h5>
                                        <label>Select the file you want other users to see.</label>
                                        <input className="form-control mt-3" type="file" accept="image/*" onChange={onUploadFileSelected}/>
                                    </>}

                                    {selectedFile && imagePreview && <>
                                        <h5>Confirm upload</h5>
                                        <label>Click upload if you want to send the image to us. Dont forget to confirm the changes by clicking Confirm.</label>
                                        <div className="position-relative mt-3" style={{width: '120px', height: '120px', zIndex: 1}}><span
                                            className="rounded-2 shadow p-1 d-inline-block position-absolute mdi mdi-cancel hover-text-danger bg-white clickable"
                                            style={{top: '-5px', right: '-5px'}}
                                            onClick={() => {
                                                setSelectedFile(null)
                                            }}></span>
                                            <div className="rounded-circle overflow-hidden img-fit-wrap" style={{width: '120px', height: '120px'}}>
                                                <img src={URL.createObjectURL(imagePreview)} className="img-fit" alt=""/>
                                            </div>
                                        </div>
                                    </>}
                                </div>
                                <input className="mt-3 btn btn-primary" type="button" onClick={uploadImage} value="Upload"/>
                            </form>
                        </div>
                    </div>
                </Section>
            </Modal.Body>
        </Modal>
    };


    return <>
        <div className="clickable" onClick={() => { setShowUploadModal(true)}}>
            <UserAvatar user={user} width={120}/>
        </div>
        <UploadModal/>
    </>
}
